import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useDashboard } from "@/contexts/DashboardContext";

function FeatureRestrict({
    message = "This feature is not available in your current plan. Upgrade to unlock advanced tools and insights.",
    title = "Feature Locked",
    features = ["Competitor tracking", "AI insights", "Market trends"],
    upgradeRoute = "/settings/billing",
}) {
    const navigate = useNavigate();

    const {setActiveView} = useDashboard();

    return (
        <div className="flex items-center justify-center h-[70vh] px-6">
            <div className="flex flex-col items-center text-center max-w-sm w-full">

                {/* Icon with concentric ring layers */}
                <div className="relative mb-6">
                    {/* Outer ring */}
                    <div className="absolute inset-0 -m-[18px] rounded-full border border-border/30 pointer-events-none" />
                    {/* Mid ring */}
                    <div className="absolute inset-0 -m-2 rounded-full border border-border/50 pointer-events-none" />
                    {/* Icon circle */}
                    <div className="w-20 h-20 rounded-full bg-muted border border-border flex items-center justify-center relative z-10">
                        <Lock className="w-8 h-8 text-muted-foreground" />
                    </div>
                </div>

                {/* Title */}
                <h2 className="text-lg font-semibold mb-2 text-foreground">
                    {title}
                </h2>

                {/* Description */}
                <p className="text-sm text-muted-foreground leading-relaxed mb-6 max-w-xs">
                    {message}
                </p>

                {/* Feature pills */}
                {/* {features?.length > 0 && (
                    <div className="flex flex-wrap gap-2 justify-center mb-7">
                        {features.map((f, i) => (
                            <span
                                key={i}
                                className="text-xs px-3 py-1 rounded-full bg-muted text-muted-foreground border border-border"
                            >
                                {f}
                            </span>
                        ))}
                    </div>
                )} */}

                {/* CTA buttons */}
                <div className="flex gap-2.5 w-full max-w-[280px]">
                    <Button
                        className="flex-1"
                        onClick={() => setActiveView("invoices")}
                    >
                        Upgrade plan
                    </Button>
                    {/* <Button
                        variant="outline"
                        className="flex-1"
                        onClick={() => navigate("/pricing")}
                    >
                        Learn more
                    </Button> */}
                </div>

            </div>
        </div>
    );
}

export default FeatureRestrict;